import {
  Box,
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  SvgIcon,
} from '@mui/material';
import { useState } from 'react';
import { GiFamilyTree } from 'react-icons/gi';
import { GrPerformance } from 'react-icons/gr';
import { HiOutlineVariable } from 'react-icons/hi';
import { TbCube3dSphere, TbSchema } from 'react-icons/tb';
import { VscSymbolEvent } from 'react-icons/vsc';
import { EventForm } from '@/components/forms/EventForm/EventForm';
import { EventFormContextProvider } from '@/components/forms/EventForm/EventFormContext';
import { useWindowContext } from '@/contexts/WindowContext';
import { ActionForm } from '../../forms/ActionForm/ActionForm';
import { ActionFormContextProvider } from '../../forms/ActionForm/ActionFormContext';
import { DiagramForm } from '../../forms/DiagramForm/DiagramForm';
import { ExtSimForm } from '../../forms/ExtSimForm/ExtSimForm';
import { LogicNodeForm } from '../../forms/LogicNodeForm/LogicNodeForm';
import { LogicNodeFormContextProvider } from '../../forms/LogicNodeForm/LogicNodeFormContext';
import { VariableForm } from '../../forms/VariableForm/VariableForm';
import { VariableFormContextProvider } from '../../forms/VariableForm/VariableFormContext';
import { MinimizedWindows } from '../Window/MinimizedWindows';
import { WindowComponent } from '../Window/Window';

export const MainCanvas: React.FC = () => {
  const actions = [
    {
      icon: (
        <SvgIcon>
          <TbSchema />
        </SvgIcon>
      ),
      name: 'New Diagram',
      content: <DiagramForm />,
    },
    {
      icon: (
        <SvgIcon sx={{ rotate: '180deg' }}>
          <GiFamilyTree />
        </SvgIcon>
      ),
      name: 'New Logic Tree',
      content: (
        <LogicNodeFormContextProvider>
          <LogicNodeForm setAsRoot />
        </LogicNodeFormContextProvider>
      ),
    },
    {
      icon: (
        <SvgIcon>
          <TbCube3dSphere />
        </SvgIcon>
      ),
      name: 'New External Sim',
      content: <ExtSimForm />,
    },
    {
      icon: (
        <SvgIcon>
          <GrPerformance />
        </SvgIcon>
      ),
      name: 'New Action',
      content: (
        <ActionFormContextProvider>
          <ActionForm />
        </ActionFormContextProvider>
      ),
    },
    {
      icon: (
        <SvgIcon>
          <VscSymbolEvent />
        </SvgIcon>
      ),
      name: 'New Event',
      content: (
        <EventFormContextProvider>
          <EventForm />
        </EventFormContextProvider>
      ),
    },
    {
      icon: (
        <SvgIcon>
          <HiOutlineVariable />
        </SvgIcon>
      ),
      name: 'New Variable',
      content: (
        <VariableFormContextProvider>
          <VariableForm />
        </VariableFormContextProvider>
      ),
    },
  ];
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // const storedHistory = JSON.parse(sessionStorage.getItem('dataHistory') || '[]');

  const { addWindow } = useWindowContext();

  // const undoChange = () => {
  //   if (storedHistory && storedHistory.length > 1) {
  //     const newHistory = storedHistory.slice(0, storedHistory.length - 1); // Remove the last item in the array
  //     sessionStorage.setItem('dataHistory', JSON.stringify(newHistory));
  //     updateAppData(undefined, newHistory[newHistory.length - 1]);
  //   }
  // };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: 3,
        position: 'relative',
        height: 'calc(100% - 65px)',
        top: '65px',
        backgroundColor: 'var(--emrald-canvas)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          transform: 'translateZ(0px)',
          flexGrow: 1,
        }}
      >
        <MinimizedWindows />

        {/* TODO Figure this out later */}
        {/* {storedHistory && storedHistory.length > 1 ? (
          <Fab color="secondary" aria-label="add" onClick={() => undoChange()}>
            <UndoIcon />
          </Fab>
        ) : null} */}

        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          sx={{ position: 'absolute', right: 16 }}
          icon={<SpeedDialIcon />}
          onClick={handleOpen}
          open={open}
          direction="down"
        >
          {actions.map(action => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              slotProps={{ tooltip: { title: action.name } }}
              onClick={() => {
                addWindow(action.name, action.content);
                handleClose();
              }}
            />
          ))}
        </SpeedDial>
      </Box>

      <WindowComponent />
    </Box>
  );
};
